import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import newUserStyles from '../styles/newUserStyles';
import BodyContainer from '../ui/BodyContainer';
import SignupSkeleton from '../ui/signupSkeleton';
import SignupThankyou from '../ui/signupSkeleton/SignupThankyou';
import CustomButton from '../ui/viewEventUi/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Services from '../services/services';
import Loader from '../ui/Loader';
import toast, { Toaster } from 'react-hot-toast';
import { isAlphabet, isEmail } from '../regexFuncs';
import { groupIcon } from '../ui/icons';
import CustomDialog from '../ui/customDialog';

const useStyles = makeStyles((theme) => newUserStyles(theme));

function SignupPage() {
  const classes = useStyles();
  const history = useHistory();
  // const [isSuccess, setIsSuccess] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [loader, setLoader] = useState(false);

  const [firstName, setFirstName] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [lastName, setLastName] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [email, setEmail] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [password, setPassword] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [confPass, setConfPass] = useState({
    error: false,
    helpertext: ' ',
    value: '',
  });

  const [phone, setPhone] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [age, setAge] = useState({
    error: false,
    helpertext: null,
    value: false,
  });

  const [terms, setTerms] = useState({
    error: false,
    helpertext: null,
    value: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const checkIsUser = async (emailId) => {
    try {
      const res = await Services.check_is_user(emailId);
      if (res.data?.responseCode === 302) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      createUser();
    }
  };

  const onChangeFirstName = (e) => {
    const value = e.target.value;
    if (value === '' || (isAlphabet(value) && value.length <= 16)) {
      setFirstName({
        error: false,
        helpertext: null,
        value: value,
      });
    }
  };

  const onChangeLastName = (e) => {
    const value = e.target.value;
    if (value === '' || (isAlphabet(value) && value.length <= 16)) {
      setLastName({
        error: false,
        helpertext: null,
        value: value,
      });
    }
  };
  const onChangeEmail = async (e) => {
    const value = e.target.value;
    setEmail({
      error: false,
      helpertext: null,
      value: value,
    });
  };

  const mailBlurHandle = async () => {
    if (isEmail(email.value)) {
      const isAlreadyUser = await checkIsUser(email.value);
      if (isAlreadyUser) {
        setEmail((prevState) => {
          return {
            ...prevState,
            error: true,
            helpertext: 'Email is already registered',
          };
        });
        return true;
      }
    }
  };

  const onChangePassword = async (e) => {
    const value = e.target.value;
    setPassword({
      error: false,
      helpertext:
        value.length < 9 ? 'Password must be at least 9 characters' : ' ',
      value: value,
    });
    setConfPass((prevState) => {
      return {
        ...prevState,
        error: false,
        helpertext: ' ',
      };
    });
  };

  const onChangeConfPass = (e) => {
    const value = e.target.value;
    setConfPass({
      error: false,
      helpertext: ' ',
      value: value,
    });
  };

  const onChangePhone = (value, country) => {
    setPhone({
      error: false,
      helpertext: null,
      value: value,
    });
  };

  const onChangeAge = (e) => {
    const value = e.target.checked;
    setAge({
      error: false,
      helpertext: ' ',
      value: value,
    });
  };

  const onChangeTerms = (e) => {
    const value = e.target.checked;
    setTerms({
      error: false,
      helpertext: ' ',
      value: value,
    });
  };

  const Validation_fun = () => {
    if (firstName.value === '') {
      setFirstName((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'First name is required',
        };
      });
    }
    if (lastName.value === '') {
      setLastName((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Last name is required',
        };
      });
    }
    if (email.value === '') {
      setEmail((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Email address is required',
        };
      });
    } else if (!isEmail(email.value)) {
      setEmail((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Email address is not valid',
        };
      });
    } else {
      mailBlurHandle();
    }

    if (password.value === '') {
      setPassword((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Password is required',
        };
      });
    } else if (password.value?.length < 9) {
      setPassword((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Password must be atleast 9 characters',
        };
      });
    }

    if (confPass.value === '') {
      setConfPass((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Confirm password is required',
        };
      });
    } else if (password.value !== confPass.value) {
      setConfPass((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Passwords are not matching',
        };
      });
    }

    if (age.value === false) {
      setAge((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Confirm your age',
        };
      });
    }

    if (terms.value === false) {
      setTerms((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Agree to Privacy Policy and Terms of Service',
        };
      });
    }

    if (
      firstName.value === '' ||
      firstName.value === undefined ||
      firstName.value === null ||
      lastName.value === '' ||
      lastName.value === undefined ||
      lastName.value === null ||
      password.value === '' ||
      password.value === undefined ||
      password.value === null ||
      password.value.length < 9 ||
      confPass.value === '' ||
      confPass.value === undefined ||
      confPass.value === null ||
      password.value !== confPass.value ||
      email.value === '' ||
      email.value === undefined ||
      email.value === null ||
      email.error ||
      !isEmail(email.value) ||
      age.value === false ||
      terms.value === false
    ) {
      return false;
    } else {
      return true;
    }
  };

  const onAccountSuccess = (msg) => {
    toast.success(msg, {
      duration: 5000,
    });
    setDialogOpen(true);
  };

  const createUser = () => {
    const okNoFor = 3;
    toast.remove();
    if (Validation_fun()) {
      let user_data = {
        firstName: firstName.value,
        lastName: lastName.value,
        email: email.value,
        password: password.value,
        // phone: null,
        userType: okNoFor,
      };
      setLoader(true);
      Services.create_user(user_data)
        .then((userResponse) => {
          if (userResponse.data.responseCode === 201) {
            setLoader(false);
            onAccountSuccess(userResponse.data.details);
          } else {
            setLoader(false);
            toast.error(userResponse.data.details, { duration: 6000 });
          }
        })
        .catch((error) => {
          setLoader(false);
          toast.error('failed', { duration: 4000 });
        });
    }
  };
  return (
    <BodyContainer title='Sign Up' icon={groupIcon()}>
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <Box display='flex' justifyContent='center' alignItems='center'>
            <form className={classes.form}>
              <Grid container>
                <SignupSkeleton
                  fError={firstName.error}
                  fHelp={firstName.helpertext}
                  fValue={firstName.value}
                  changeFName={onChangeFirstName}
                  handleEnter={handleEnter}
                  inputStyles={classes.inputStyles}
                  LError={lastName.error}
                  LHelp={lastName.helpertext}
                  LValue={lastName.value}
                  changeLName={onChangeLastName}
                  EError={email.error}
                  EHelp={email.helpertext}
                  EValue={email.value}
                  changeEmail={onChangeEmail}
                  mailBlurHandle={mailBlurHandle}
                  PwError={password.error}
                  PwHelp={password.helpertext}
                  PwValue={password.value}
                  changePassword={onChangePassword}
                  CError={confPass.error}
                  CHelp={confPass.helpertext}
                  CValue={confPass.value}
                  changeConfPass={onChangeConfPass}
                  showPassword={showPassword}
                  handleClickShowPassword={handleClickShowPassword}
                  handleMouseDownPassword={handleMouseDownPassword}
                  PError={phone.error}
                  PHelp={phone.helpertext}
                  PValue={phone.value}
                  changePhone={onChangePhone}
                  isUserPage={true}
                  phoneErrorCls={classes.phoneErrorCls}
                  termsContainer={classes.termsContainer}
                  policyLink={classes.policyLink}
                  termsText={classes.termsText}
                  checkBoxStyles={classes.checkBoxStyles}
                  AgeError={age.error}
                  AgeHelp={age.helpertext}
                  AgeValue={age.value}
                  changeAge={onChangeAge}
                  TermsError={terms.error}
                  TermsHelp={terms.helpertext}
                  TermsValue={terms.value}
                  changeTerms={onChangeTerms}
                  showPhoneInput={false}
                />
              </Grid>
              <div className={classes.btnDiv}>
                <CustomButton
                  btnStyle={classes.button1}
                  clickHandle={() => history.goBack()}
                  btnText={'Cancel'}
                />
                <CustomButton
                  btnStyle={classes.button}
                  clickHandle={createUser}
                  btnText={'Sign Up'}
                />
              </div>
            </form>
          </Box>
          <CustomDialog
            open={dialogOpen}
            handleClose={() => {
              // setDialogOpen(false);
              // history.push('/');
            }}
            popOverContainer={classes.popOverContainer}
            titleText={'Account Created'}
            contentText={
              'Thankyou for creating an account! Please check email to verify your account.'
            }
            btnOkCls={classes.btnStyleJoin}
            handleOk={() => {
              setDialogOpen(false);
              history.push('/');
            }}
            btnOkText={'Sign In'}
            arrowIconCls={classes.arrowIcon}
          />
        </Paper>
      </Grid>
      <Toaster position='top-center'></Toaster>
      <Loader
        open={loader}
        // msg={redirectTime ? `Redirecting to Sign-in in ${redirectTime} s` : ''}
      />
    </BodyContainer>
  );
}

export default SignupPage;
